import React from "react";
import {BreachRxAuthProvider} from "@breachrx/client-auth";
import PropTypes from "prop-types";
import {AuthContext, AuthProvider as LegacyAuthProvider} from "./Context/AuthProvider";
import Loader from "../Loader";
import {isKeycloakAuthEnabled} from "./AuthUtils";

const config = {
  client_id: process.env.AUTH_CLIENT_ID,
  authority: process.env.AUTH_AUTHORITY,
  redirect_uri: window.location.origin,
  scope: process.env.AUTH_SCOPE,
  response_type: process.env.AUTH_RESPONSE_TYPE,
  post_logout_redirect_uri: window.location.origin,
};

export const AuthWrapper = ({children}) => {
  if (isKeycloakAuthEnabled()) {
    return (
      <BreachRxAuthProvider
        config={config}
        Context={AuthContext}
        LoaderComponent={<Loader fullViewingHeight />}
      >
        {children}
      </BreachRxAuthProvider>
    );
  }

  return <LegacyAuthProvider>{children}</LegacyAuthProvider>;
};

AuthWrapper.propTypes = {
  children: PropTypes.node,
};
